<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
        <form class="form-horizontal px-4 py-4" @submit.prevent="submit">
          <div class="mb-4">
            <input
              class="
                bg-blue-500
                text-white text-xs
                hover:bg-blue-700
                py-1
                px-3
                rounded
              "
              type="submit"
              value="Save"
            />
            <a
              class="
                bg-green-500
                text-white text-xs
                hover:bg-green-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deploy"
              >Deploy</a
            >
            <a
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deploy"
              >Export</a
            >
            <a
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deploy"
              >Duplicate</a
            >
            <a
              class="
                bg-red-500
                text-white text-xs
                hover:bg-red-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deploy"
              >Delete</a
            >
          </div>

          <BsEdit
            :slug="slug"
            :createDef="createDef"
            :routeDef="moduleRoute"
            ref="formRenderer"
          >
          </BsEdit>
        </form>

        <DxToast
          v-model:visible="isVisible"
          v-model:message="message"
          v-model:type="type"
        />
      </div>
    </div>
  </app-layout>
</template>

<style scoped>
.link-btn-style {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>




<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import { DxToast } from "devextreme-vue/toast";

let collapsed = false;

export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    slug:String,
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    JetNavLink,
    DxToast,
  },

  data() {
    return {
      title: "Create Module",
      form: this.$inertia.form(),
      isVisible: false,
      message: '',
      type: 'success',
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },

    submit() {
      // this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData);
      this.$refs.formRenderer.formData.route_slug = this.slug

      this.form.post(route(this.moduleRoute + ".index", this.$refs.formRenderer.formData));


    },
  },
  mounted() {
    console.log("CREATE DEF",this.createDef);

  },
};
</script>
